<template>
  <div>
    <div style="margin-bottom: 32px; margin-top: -8px; display: flex; justify-content: space-between;">
      <div class="content-input">
        <div class="content-input-item">
          <label>记录状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 10em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <el-button type="primary" @click="getPage(true)"> 查询 </el-button>
        </div>
      </div>
      <div v-if="ipState != -1" class="content-input-item" style="padding-right: 0;">
        <el-button v-if="ipState == 1" type="success" @click="updateIpCityState(2)" v-loading="updateLoading"> 标记IP为正常 </el-button>
        <el-button v-else type="danger" @click="updateIpCityState(1)" v-loading="updateLoading"> 标记IP为异常 </el-button>
      </div>
    </div>
    <div>
      <el-table
          ref="multipleTableRef"
          :data="pageDataList"
          style="width: 100%"
          border
          v-loading="listLoading"
      >
        <el-table-column property="createTime" label="时间"/>
        <el-table-column property="ipCity" label="IP地址"/>
        <el-table-column property="livesCity" label="现居城市"/>
      </el-table>
      <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>

import {ipCityAbnormalList, updateIpCityAbnormalState } from '@/api/url'
import {getFormData, postFormData} from '@/api/api'

export default {
  name: "ipCityAbnormalDialog",
  props: {
    value: Object
  },
  data() {
    return {
      userId: this.value.id,
      ipState: this.value.ipState,

      stateArray: [
        {label: '不限', value: -1},
        {label: '标记前记录', value: 1},
        {label: '标记后记录', value: 2},
      ],
      state: -1,

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['userId'] = this.userId;
      param['state'] = this.state;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(ipCityAbnormalList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    //更新ip异常状态
    updateIpCityState(state) {
      this.$confirm('确定是否标记IP为' + (state == 2?'【正常】':'【异常】')).then(()=>{
        this.updateLoading = true
        let param = {}
        let userIdArr = []
        userIdArr.push(this.userId)
        param['idArr'] = userIdArr
        param['state'] = state
        postFormData(updateIpCityAbnormalState, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.$emit('confirm', param);
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.updateLoading = false
        }).catch(()=>{
          this.updateLoading = false
        })
      })
    },

  },
  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>

</style>
